import { EnumLeverageProductsIndication } from "src/api/client/extended-search.api.types";
import { SearchQueryParams } from "../search.types";

export const mapLeverageProductsIndicationFromQuery = (urlParams: URLSearchParams): EnumLeverageProductsIndication => {
    if (urlParams.get(SearchQueryParams.WikifoliosWithLeverageProducts) === "true") {
        return EnumLeverageProductsIndication.WikifoliosWithLeverageProducts;
    }

    if (urlParams.get(SearchQueryParams.WikifoliosWithoutLeverageProducts) === "true") {
        return EnumLeverageProductsIndication.WikifoliosWithoutLeverageProducts;
    }

    return EnumLeverageProductsIndication.AllWikifolios;
};

export const mapLeverageProductsIndicationToQuery = (leverageProductsIndication: EnumLeverageProductsIndication) => {
    if (leverageProductsIndication === EnumLeverageProductsIndication.WikifoliosWithLeverageProducts) {
        return `${SearchQueryParams.WikifoliosWithLeverageProducts}=true`;
    }

    if (leverageProductsIndication === EnumLeverageProductsIndication.WikifoliosWithoutLeverageProducts) {
        return `${SearchQueryParams.WikifoliosWithoutLeverageProducts}=true`;
    }

    return "";
};
